import { AnyAction, combineReducers } from '@reduxjs/toolkit';
import dataReducer from './data';
import requestsReducer from './requests';
import locationReducer from './location';
import confReducer from './conf';
import volatileReducer from './volatile';
import sessionReducer from './session';

const appReducer = combineReducers({
    data: dataReducer,
    requests: requestsReducer,
    session: sessionReducer,
    location: locationReducer,
    conf: confReducer,
    volatile: volatileReducer
});

export type AppState = ReturnType<typeof appReducer>;

const rootReducer = (state: AppState | undefined, action: AnyAction): AppState => {
    if (action.type === 'USER_LOGOUT') {
        return appReducer(undefined, action);
    }
    return appReducer(state, action);
};

export default rootReducer;
